import { useMemo, useState } from 'react';
import { groupThousandsTR } from '../../utils/formatting';

export default function useAmountCurrency({
                                              linkData,
                                              finalRates,
                                              selectedInstallment,
                                              formatTRY,
                                              getTotalWithCommission,
                                              validation
                                          }) {
    const [displayAmount, setDisplayAmount] = useState('');
    const [selectedCurrency, setSelectedCurrency] = useState('TL');

    const convertToTL = (baseAmountInSelectedCurrency, currencyToUse) => {
        let converted = baseAmountInSelectedCurrency;

        if (currencyToUse === 'USD' && finalRates?.usdFinalRate) {
            converted *= finalRates.usdFinalRate;
        } else if (currencyToUse === 'EUR' && finalRates?.eurFinalRate) {
            converted *= finalRates.eurFinalRate;
        } else if (currencyToUse === 'GBP' && finalRates?.gbpFinalRate) {
            converted *= finalRates.gbpFinalRate;
        }

        return converted;
    };

    const handleAmountChange = (e, newCurrency) => {
        // Link sabit tutarlı ise input değişmesin
        if (linkData?.fixedAmount != null) return;

        const currencyToUse = newCurrency || selectedCurrency;
        const raw = (e.target.value || '').trim();

        // Her şeyi sildiyse
        if (!raw) {
            setDisplayAmount('');
            validation.setFieldValue('amount', '');
            return;
        }

        // TR formatı:
        // .  => binlik ayırıcı (tamamen kaldır)
        // ,  => ondalık ayırıcı
        const noDots = raw.replace(/\./g, '');
        const hasComma = noDots.includes(',');

        let intPartRaw = noDots;
        let fracPartRaw = '';

        if (hasComma) {
            const [intPart, fracPart] = noDots.split(',', 2);
            intPartRaw = intPart ?? '';
            fracPartRaw = fracPart ?? '';
        }

        const intDigits = (intPartRaw || '').replace(/\D/g, '');
        const fracDigits = (fracPartRaw || '').replace(/\D/g, '').slice(0, 2);

        // Tam kısım da yok, virgül de yoksa: muhtemelen anlamsız giriş
        if (!intDigits && !hasComma) {
            setDisplayAmount(raw);
            validation.setFieldValue('amount', '');
            return;
        }

        const normalizedInt = intDigits ? String(parseInt(intDigits, 10)) : '0';

        // Sayısal string (nokta ondalık olacak)
        let normalizedStr = normalizedInt;
        if (hasComma && fracDigits) {
            normalizedStr += '.' + fracDigits;
        }

        const baseAmountInSelectedCurrency = parseFloat(normalizedStr || '0') || 0;
        const convertedTLAmount = convertToTL(baseAmountInSelectedCurrency, currencyToUse);

        // Görünen kısım için binlikleri nokta ile grupla
        const groupedInt = groupThousandsTR(normalizedInt);
        let display = groupedInt;

        if (hasComma) {
            if (noDots.endsWith(',')) {
                // Kullanıcı "12," yazmış, kuruşları daha girmedi
                display = `${groupedInt},`;
            } else {
                display = `${groupedInt},${fracDigits}`;
            }
        }

        validation.setFieldValue('amount', convertedTLAmount.toFixed(2)); // Formik: TL numeric
        setDisplayAmount(display);                                         // Input: 1.234,56 format
    };

    const handleCurrencyChange = (e) => {
        // Sabit tutarlı linkte para birimi linkten gelir; kullanıcı değiştiremez.
        if (linkData?.fixedAmount != null) return;
        const newCurrencyValue = e.target.value;
        setSelectedCurrency(newCurrencyValue);
        // Mevcut displayAmount üzerinden, yeni kura göre TL'yi tekrar hesapla
        handleAmountChange({ target: { value: displayAmount } }, newCurrencyValue);
    };

    const totalToPayText = useMemo(() => {
        const amt = parseFloat(validation.values.amount || '0');
        if (isNaN(amt) || amt <= 0) return null;
        return formatTRY(getTotalWithCommission(amt, selectedInstallment.commission));
    }, [validation.values.amount, selectedInstallment.commission, formatTRY, getTotalWithCommission]);

    return {
        displayAmount,
        setDisplayAmount,
        selectedCurrency,
        setSelectedCurrency,
        handleAmountChange,
        handleCurrencyChange,
        totalToPayText
    };
}